module.exports = __webpack_public_path__ + "img/authorization-invoice.87f208bb.svg";